import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from "../../apa/Launcher";
import DeviceStorage from "../../../components/DeviceStorage/DeviceStorage";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class EpgTask extends AbstractRequestTask {
  constructor(parameters) {
    super();
    this.customParameters = parameters;
  }

  getHeaders() {
    return {};
  }

  getParams() {
    const params = super.getParams();
    const sub_region = DeviceStorage.getItem('sub_region');
    if(sub_region){
      params.subregion = sub_region;
    }
    delete params.user_token;
    return Object.assign({}, params, this.customParameters );
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");

    return `${http}${url}/services/epg/menu`;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default EpgTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/epg/FiltersTask.js